import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {persistState} from "@datorama/akita";
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import Moment from 'moment';
import 'moment/locale/it'
import {environment} from "./environments/environment";
import {getMessaging} from "firebase/messaging";

const app = initializeApp(environment.firebase);
const analytics = getAnalytics(app);
const messaging = getMessaging();

registerLocaleData(localeIt);
Moment.locale('it')

const storage = persistState({
  include: ['session']
});
const providers = [{provide: 'persistStorage', useValue: storage}];

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));
